<template>
  <v-dialog :value="show" persistent max-width="850px">
    <v-card class="flex-col-start-start gap-4 pa-6 direction-ltr">
      <div class="text-h6 mt-1">Recommended Parameters:</div>
      <v-row class="w-100 direction-ltr">
        <v-col
          cols="4"
          v-for="parameter in recommendationResult.parameters"
          :key="parameter.name"
        >
          <v-card outlined class="pa-4 flex-row-start-center gap-2">
            <div class="text-body-2 mainBlue--text">{{ parameter.name }}:</div>
            <div class="text-body-2 text--text">{{ parameter.value }}</div>
          </v-card>
        </v-col>
      </v-row>

      <div class="text-h6 mt-1">Recommended Result:</div>
      <v-row class="w-100 direction-ltr">
        <v-col cols="6" v-for="resultParam in resultParams" :key="resultParam">
          <v-card outlined class="pa-4 flex-row-start-center gap-2">
            <div class="text-body-2 mainBlue--text">{{ $t(resultParam) }}:</div>
            <div class="text-body-2 text--text">
              {{ recommendationResult[resultParam] }}
            </div>
          </v-card>
        </v-col>
      </v-row>

      <div class="w-100 flex-row-end-center gap-3">
        <v-btn
          class="white--text"
          color="infoGreen"
          min-width="150"
          :loading="loading"
          @click="onSave"
        >
          {{ $t("save") }}
        </v-btn>
        <v-btn
          class="white--text"
          color="mainBlue"
          min-width="150"
          @click="onClose"
        >
          {{ $t("close") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";
import { SAVE_HMI_OPERATION } from "@/core/services/store/modules/hmi/hmi.module";
import { mapGetters } from "vuex";

export default {
  name: "RecommendationResult",

  props: {
    show: { type: Boolean, default: false },
  },

  data() {
    return {
      loading: false,
      resultParams: ["carbon", "metallization"],
    };
  },

  computed: {
    ...mapGetters(["recommendationResult"]),
  },

  methods: {
    onClose() {
      this.$emit("close");
    },
    async onSave() {
      this.loading = true;
      await this.$store;
      this.$store
        .dispatch(SAVE_HMI_OPERATION, {
          operationId: this.recommendationResult.id,
          type: "recommendation",
        })
        .then(() => {
          this.$store.commit(SET_ALERT, {
            text: this.$t("saveMessage"),
            isError: false,
          });
        })
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        })
        .finally(() => {
          this.loading = false;
          this.onClose();
        });
    },
  },
};
</script>
